import(/* webpackMode: "eager" */ "/usr/src/app/app/[locale]/auth/forgot-password/page.tsx");
